import { render } from "./AttendanceEdit.vue?vue&type=template&id=678bfe61"
import script from "./AttendanceEdit.vue?vue&type=script&lang=js"
export * from "./AttendanceEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__